import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { setSection } from "../../../assignmentSlice";

const SentenceReorder = ({
  currentPage,
  currentIndex,
  pageList,
  section,
  setPageList,
  setIsIncorrectOverlayVisible,
}) => {
  const dispatch = useDispatch();

  const [sentences, setSentences] = useState(currentPage.data.question);

  const handleDragEnd = (result) => {
    const { source, destination } = result;

    // 목적지가 없으면 (드롭하지 않은 경우) 아무 작업도 하지 않음
    if (!destination) return;

    // 같은 위치에 드롭했을 경우 아무 작업도 하지 않음
    if (source.index === destination.index) return;

    // 리스트 항목 순서 변경
    const updatedSentences = Array.from(sentences);
    const [movedItem] = updatedSentences.splice(source.index, 1);
    updatedSentences.splice(destination.index, 0, movedItem);

    setSentences(updatedSentences);
  };

  const handleSubmit = () => {
    const bool = currentPage.data.answer.every(
      (sentence, index) => sentence === sentences[index]
    );

    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          data: {
            ...page.data,
            input: [...page.data.input, sentences],
          },
          isSubmitted: bool,
        };
      }
      return page;
    });

    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    setIsIncorrectOverlayVisible(true);
    setTimeout(() => {
      setIsIncorrectOverlayVisible(false);
      console.log(currentPage);
    }, 600);
  };

  useEffect(() => {
    setSentences(currentPage.data.question);
  }, [currentIndex]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "80%",
        height: "100%",
      }}
    >
      <div style={{ fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "20px", fontWeight: 700, textAlign: "center", marginBottom: "12px" }}>
        주어진 문장에 이어질 순서로, 카드를 꾹 눌러 끌어 배열하세요.
      </div>
      <div
        style={{
          marginTop: "16px",
          marginBottom: "18px",
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "16px" : "22px",
          lineHeight: 1.7,
          color: "#0E141B",
        }}
      >
        {currentPage.data.question_text}
      </div>
      <div>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="sentences-list">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{
                  padding: "10px",
                  borderRadius: "5px",
                  width: "min(640px, 88vw)", // 시안 05 pane 폭
                }}
              >
                {sentences?.map((sentence, index) => (
                  <Draggable
                    key={sentence}
                    draggableId={sentence}
                    index={index}
                    isDragDisabled={currentPage.isSubmitted}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          // ECHO 시안 05 .dragrow
                          marginBottom: "7px",
                          backgroundColor: currentPage.isSubmitted
                            ? "#F4F8F7"
                            : "#fff",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "17px",
                          lineHeight: 1.5,
                          display: "flex",
                          alignItems: "center", // [v10] 텍스트 세로 가운데
                          gap: "8px",
                          padding: Math.min(window.innerWidth, window.screen.width) <= 768 ? "8px 10px" : "9px 11px", // [v10] 모바일 날씬
                        }}
                      >
                        {/* 드래그 핸들 (점 8개) */}
                        <div
                          {...provided.dragHandleProps}
                          style={{
                            // ECHO 시안 05 .grip — 배경 블록 없이 점만
                            backgroundColor: "transparent",
                            // [모바일 수정] ① touchAction:none — 핸들에서 시작한
                            // 터치를 브라우저 스크롤이 가로채 드래그가 안 되던
                            // 원인. ② 패딩 확대 — 점 영역이 13×21px뿐이라 엄지로
                            // 잡을 수 없었음 → 터치 타깃 44px 확보(시각은 점 그대로).
                            touchAction: "none",
                            padding:
                              Math.min(window.innerWidth, window.screen.width) <= 768
                                ? "6px 10px 6px 4px" // [v10] 날씬하게
                                : "2px 2px 0 0",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            cursor: "grab",
                            flex: "none",
                          }}
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(2, 5px)",
                              gap: "3px",
                            }}
                          >
                            {Array(8)
                              .fill(0)
                              .map((_, i) => (
                                <div
                                  key={i}
                                  style={{
                                    width: "5px",
                                    height: "5px",
                                    backgroundColor: "#B9C1C9", // --ink-25
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              ))}
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "0",
                            color: "#3A434E", // --ink-70
                          }}
                        >
                          {sentence}
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      <button
        style={{
          // [제출 인라인] 모바일: 카드 목록 아래 흐름 속 배치 (둥둥 제거)
          position: Math.min(window.innerWidth, window.screen.width) <= 768 ? "static" : "absolute",
          alignSelf: Math.min(window.innerWidth, window.screen.width) <= 768 ? "flex-end" : undefined,
          display: Math.min(window.innerWidth, window.screen.width) <= 768 ? "block" : undefined,
          marginLeft: Math.min(window.innerWidth, window.screen.width) <= 768 ? "auto" : undefined,
          marginTop: Math.min(window.innerWidth, window.screen.width) <= 768 ? "18px" : 0,
          bottom: Math.min(window.innerWidth, window.screen.width) <= 768 ? undefined : "90px",
          right: Math.min(window.innerWidth, window.screen.width) <= 768 ? undefined : "60px",
          padding: Math.min(window.innerWidth, window.screen.width) <= 768 ? "9px 26px" : "10px 32px",
          backgroundColor: currentPage.isSubmitted ? "#E6EDEC" : "#0E141B", // cur-submit
          color: currentPage.isSubmitted ? "#7A8490" : "white",
          border: "none",
          fontSize: "16px",
          fontWeight: 700,
          borderRadius: "999px",
          cursor: "pointer",
        }}
        onClick={currentPage.isSubmitted ? null : () => handleSubmit()}
      >
        제출하기
      </button>
    </div>
  );
};

export default SentenceReorder;
